import { gql } from "graphql-request";

export const projectPermissions = {
  getProjectPermissions: gql`
    query ProjectPermissions($projectId: String!, $orgType: TenantType!) {
      projectPermissions(projectId: $projectId, orgType: $orgType) {
        canAssignUserAccountToProject
        canAssignUserAccountRoleType
        canEditProjectMembers
        canChangeProjectMembersStatus
        canCreateNewProject
        canChangeProjectStatus
        canEditHADecisionData
        canEditProjectInformation
        canEditParticipationType
        canViewContent
        canUploadContent
        canManageStructuredDocument
        canReorderStructuredDocument
        canReadStructuredTemplate
        canManageStructuredTemplate
        canEditContent
        canEditContentName
        canEditOwnedContentName
        canEditContentMetadata
        canEditOwnedContentMetadata
        canSendContentToTenancy
        canSendCopyToSponsor
        canDeleteContentToTenancy
        canDeleteOwnedContent
        canDeleteQuestion
        canDeleteOwnQuestion
        canCreateQuestion
        canEditOwnedQuestion
        canEditQuestion
        canEditQuestionResponse
        canChangeOwnedQuestionStatus
        canChangeQuestionDueDate
        canChangeQuestionStatus
        canChangeQuestionResponseStatus
        canImportReferenceOrExternalQuestion
        canEditReferenceOrExternalQuestion
        canChangeReferenceOrExternalQuestionStatus
        canSendCopyQuestion
        canSubmitQuestionResponse
        canSubmitReferenceOrExternalQuestion
        canExportQuestionAndResponse
        canCreateOwnedCommentsAsset
        canCreateComments
        canResolveComments
        canCreateTask
        canCompleteTask
        canManageTask
        canManageOwnTask
        canViewAssignToAllParentTask
        canChangeContentStatus
        canSendHAInvitation
        canManageProjectInvitations
        canCreateProjectInvitations
        canManageMilestones
        canCreatePrivateInlineComment
        canCreatePeerInlineComment
        canCreatePublicInlineComment
        canResolveOwnInlineComments
        canResolveOthersInlineComments
        canChangeOwnedContentStatus
        canBeAssignedToTask
      }
    }
  `,
};
